import { render, staticRenderFns } from "./HomeApps.vue?vue&type=template&id=2f346bfc&scoped=true"
import script from "./HomeApps.vue?vue&type=script&lang=js"
export * from "./HomeApps.vue?vue&type=script&lang=js"
import style0 from "./HomeApps.vue?vue&type=style&index=0&id=2f346bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f346bfc",
  null
  
)

export default component.exports